import styled from "@emotion/styled";
import { css, keyframes } from "@emotion/react";
import { tablet } from "../../../../media";

const slideDown = keyframes`
  from { transform: translateY(0); opacity: 1; }
  to { transform: translateY(100%); opacity: 0; }
`;

const slideUp = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;
export const DockWrapper = styled.div<
  { isAnimatingOut?: boolean; isAnimatingIn?: boolean }
>`
  position: relative;
  margin: 0 16px calc(env(safe-area-inset-bottom, 0px) + 16px);

  border-radius: 12px;
  background: #23252a;
  border-top: 1px solid #2b2d33;
  box-shadow: 0px -2px 12px rgba(94, 132, 237, 0.45);

  display: flex;
  flex-direction: column;
  min-height: 160px;
  max-height: calc(100dvh - 140px);
  padding: 16px;
  gap: 12px;
  overflow: hidden;

  box-sizing: border-box;

  ${tablet`
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
  `}

  ${(props) =>
  props.isAnimatingOut &&
  css`
    animation: ${slideDown} 0.3s forwards;
  `}

  ${(props) =>
  props.isAnimatingIn &&
  css`
    animation: ${slideUp} 0.3s forwards;
  `}

`;

export const DockHandleWrapper = styled.div`
  height: 12px;
  justify-content: center;
  align-items: center;
  display: inline-flex;
`;

export const DockHandle = styled.div`
  width: 36px;
  height: 4px;
  background: #2b2d33;
  border-radius: 999px;
`;

export const DockTextArea = styled.textarea`
  max-height: 120px;
  min-height: 56px;
  padding: 12px;
  border-radius: 12px;
  border: none;
  background: transparent;
  resize: none;
  outline: none;

  color: #b7bdcb;
  font-size: 16px;
  font-family: Inter;
  font-weight: 400;
  line-height: 140%;
  word-wrap: break-word;
`;

export const DockActions = styled.div`
  display: inline-flex;
  align-self: stretch;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
`;

export const DockActionButtonContainer = styled.div`
  width: 60px;
  height: 60px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  display: inline-flex;
`;

export const DockActionButton = styled.button`
`;

export const DockItem = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: 60px;
  width: 60px;
  cursor: pointer;
  z-index: 1;
  &:focus-visible {
    outline: 2px solid #b7bdcb;
    outline-offset: 2px;
  }
`;

export const DockIcon = styled.img`
  display: block;
`;

export const DockLabel = styled.span`
  font-family:
    Inter,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 11px;
  line-height: 120%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #b7bdcb;
`;

export const RecordingWrapper = styled.div`
  height: 32px;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  display: inline-flex;
`;

export const RecordingHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const RecordingDot = styled.div`
  width: 8px;
  height: 8px;
  background: #5e84ed;
  border-radius: 999px;
`;

export const RecordingTitle = styled.div`
  color: #b7bdcb;
  font-size: 15px;
  font-family: Inter;
  font-weight: 400;
  line-height: 18px;
  word-wrap: break-word;
`;
export const RecordingTimer = styled.div`
  color: #b7bdcb;
  font-size: 15px;
  font-family: Inter;
  font-weight: 400;
  line-height: 18px;
  word-wrap: break-word;
`;

export const RecordingMiddle = styled.div`
  height: 56px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  display: inline-flex;
`;

export const RecordingBottom = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 32px;
  display: inline-flex;
  height: auto;
  box-sizing: border-box;
`;

export const RerecordConfirmation = styled.div`
  display: flex;
  width: 311px;
  padding: 24px 20px;
  background: #1e1f22;
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.45);
  border-radius: 16px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  opacity: 0;
  transform: scale(0.9);
  padding-top: 26px;
  &.visible {
    opacity: 1;
    transform: scale(1);
  }
`;

export const ModalOverlay = styled.div<{ visible: boolean }>`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  background: rgba(0, 0, 0, 0.40);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1002;
  opacity: ${(props) => props.visible ? 1 : 0};
  visibility: ${(props) => props.visible ? "visible" : "hidden"};
  transition: opacity 0.3s ease-out, visibility 0.3s ease-out;
`;

export const ModalContent = styled.div<{ visible: boolean }>`
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  opacity: ${(props) => props.visible ? 1 : 0};
  transform: ${(props) => props.visible ? "scale(1)" : "scale(0.9)"};
`;

export const TitleAndCloseWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DiscardAndReRecordTitleSpan = styled.span`
  color: #e9ecf5;
  font-size: 16px;
  font-family: Inter;
  font-weight: 600;
  line-height: 120%;
  word-wrap: break-word;
`;

export const DiscardAndReRecordDescriptionSpan = styled.span`
  color: #b7bdcb;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 150%;
  word-wrap: break-word;
`;

export const CTAWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const CancelButton = styled.button`
  display: flex;
  color: #b7bdcb;
  font-size: 15px;
  font-family: Inter;
  font-weight: 600;
  line-height: 140%;
  word-wrap: break-word;
  height: 44px;
  padding: 12px 16px;
  overflow: hidden;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 0px;
  outline: 0px;
  cursor: pointer;
`;

export const DiscardButton = styled.button`
  color: #5e84ed;
  font-size: 15px;
  font-family: Inter;
  font-weight: 600;
  line-height: 21px;
  word-wrap: break-word;
  outline: none;
  border: none;
  background: transparent;
`;

export const ReRecordButton = styled.button`
  display: flex;
  color: white;
  font-size: 15px;
  font-family: Inter;
  font-weight: 600;
  line-height: 140%;
  word-wrap: break-word;
  height: 44px;
  padding: 12px 24px;
  background: #d65f46;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  border: 0px;
  outline: 0px;
  cursor: pointer;
`;

export const RecordingTranscriptHeader = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #b7bdcb;
  font-size: 15px;
  font-family: Inter;
  font-weight: 500;
  line-height: 140%;
  word-wrap: break-word;
`;

export const TranscriptContainer = styled.div`
  // width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  background: #23252a;
  border-radius: 12px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  gap: 8px;
  // margin-bottom: 285px;
`;

export const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const SkeletonLine = styled.div<{ width?: string }>`
  height: 14px;
  background: linear-gradient(90deg, #2a2d33 0%, #3a3d43 50%, #2a2d33 100%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  border-radius: 4px;
  width: ${(props) => props.width || "100%"};
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.img`
  width: 21px;
  height: 21px;
  animation: ${rotate} 1s linear infinite;
`;

export const SpinnerSpan = styled.span`
  color: #B7BDCB;
  font-size: 13px;
  font-family: Inter;
  font-weight: 500;
  line-height: 140%
  word-wrap: break-word;
`;

export const TranscriptErrorSpan = styled.span`
  color: #e9ecf5;
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
  word-wrap: break-word;
`;

export const TranscriptBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 16px;
  gap: 8px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const TranscriptTextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  gap: 12px;
  flex: 1;
  min-height: 0;
`;

export const TranscriptText = styled.span`
  color: rgba(233, 236, 245, 0.95);
  font-size: 16px;
  font-family: Inter;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.1px;
  word-wrap: break-word;
  overflow-y: auto;
`;

export const TranscriptTextHiddenBottomArea = styled.div`
  position: absolute;
  bottom: -1px;
  width: 100%;
  height: 64px;
  background: linear-gradient(180deg, rgba(30, 31, 34, 0) 0%, #23252a 100%);
  transition: opacity 0.3s ease;
  pointer-events: none;
`;

export const AddFileButton = styled.button`
  color: #5e84ed;
  font-size: 16px;
  font-family: Inter;
  font-weight: 500;
  word-wrap: break-word;

  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 12px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const AttachmentFiles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 95px;
  overflow-y: auto;
`;

export const AttachmentFileItem = styled.div`
  display: flex;
  padding: 4px 12px 4px 8px;
  background: #1e1f22;
  border-radius: 12px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  gap: 8px;
`;

export const AttachmentFileImg = styled.img`
  width: 21px;
  height: 20px;
`;
export const AttachmentFileItemSpan = styled.span`
  color: #e9ecf5;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 140%;
  word-wrap: break-word;
  flex-grow: 1;
`;

export const UploadHint = styled.div<{ isNearLimit?: boolean }>`
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  color: ${(props) => (props.isNearLimit ? '#ff8800' : '#6e7481')};
  padding: 0 4px;
`;

export const FileError = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #b94c37;
`;
